<template>
    <div :class="{'form-constructor-wrap': true}">
        <v-form
            :class="{ 
                'wrapperForm': true, 
                'overflow-y-auto': true, 
                'overflow-x-hidden': true,
                'd-flex': !columns.length, 
                'align-center': !columns.length 
            }"
            ref="reqForm"
            lazy-validation
        >
            <v-row v-if="columns.length" dense>
                <v-col v-for="(item) in columns" :key="item.id" cols="12" sm="12" :md="item.type == 2 ? '6' : '12'" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>

                            <div class="form-box-title title-with-right-part">
                                <span>{{ item.name?.[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] ?? 'Column' }}</span>
                            </div>

                            <v-row v-for="requisite in getColumnRequisites(item.fields)" :key="requisite.KeyName" :class="{'full-width-row': item.type == 1}" no-gutters>
                                <v-col cols="12" sm="12" :md="item.type == 1 ? '2' : '4'" class="d-flex align-center">
                                    <label class="f-label flex-1">{{ requisite.Name[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] }}</label>
                                </v-col>
                                <v-col>
                                    <div v-if="!editable" class="onlyReadData">
                                        <!-- Текст -->
                                        <template v-if="requisite.RequisiteType == 0">
                                            {{ requisite.Value ? requisite.Value : $t('не_указано') }}
                                        </template>
                                        <!-- Логический -->
                                        <template v-if="requisite.RequisiteType == 1">
                                            {{ requisite.Value === 'true' ? $t('Да') : $t('Нет') }}
                                        </template>
                                        <!-- Дата -->
                                        <template v-if="requisite.RequisiteType == 2">
                                            {{ requisite.Value && $moment(requisite.Value).isValid() ? $moment(requisite.Value).format('DD.MM.YYYY') : $t('не_указано') }}
                                        </template>                                        
                                        <!-- Сотрудник -->
                                        <template v-if="requisite.RequisiteType == 3">
                                            <v-workplace-chip v-if="requisite.Value" :id="requisite.Value" :name="requisite.DisplayValue" />
                                            <template v-else>
                                                {{ $t('не_указано') }}
                                            </template>
                                        </template>
                                        <!-- Организация -->
                                        <template v-if="requisite.RequisiteType == 4">
                                            <v-enterprise-chip v-if="requisite.Value" :id="requisite.Value" :name="requisite.DisplayValue" />
                                            <template v-else>
                                                {{ $t('не_указано') }}
                                            </template>
                                        </template>
                                    </div>
                                    <template v-else>
                                        <div :class="[requisite.RequisiteType == 3 || requisite.RequisiteType == 4 ? 'icon-click-row-group icrg-align-center' : '']">

                                            <!-- Кнопка для типов Сотрудние и Организация -->
                                            <div v-if="requisite.RequisiteType == 3 || requisite.RequisiteType == 4" @click="onSelect(requisite)">
                                                <v-icon small>
                                                    fas fa-edit
                                                </v-icon>
                                            </div>

                                            <!-- Текст -->
                                            <v-text-field 
                                                v-if="requisite.RequisiteType == 0"
                                                :value="requisite.Value"
                                                @input="update({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].Value`, value: $event })"
                                                hide-details
                                                outlined
                                                dense
                                                :required="requisite.IsRequired"
                                                :rules="requisite.IsRequired ? requiredRule : []"
                                            />

                                            <!-- Логический -->
                                            <v-switch
                                                v-if="requisite.RequisiteType == 1"
                                                :input-value="requisite.Value === 'true'"
                                                @change="update({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].Value`, value: $event })"
                                                inset
                                                hide-details
                                                class="cust-switch"
                                            />
                                            
                                            <!-- Дата -->
                                            <v-menu
                                                v-if="requisite.RequisiteType == 2"
                                                v-model="dateMenus[requisite.index]"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        :value="requisite.Value ? $moment(requisite.Value).format('DD.MM.YYYY') : ''"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        hide-details
                                                        outlined
                                                        dense
                                                        class="datepick-input"
                                                        clearable
                                                        @click:clear="updateSource({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].Value`, value: null })"
                                                        :required="requisite.IsRequired"
                                                        :rules="requisite.IsRequired ? requiredRule : []"
                                                    >
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker
                                                    :value="requisite.Value"
                                                    @input="onDateInput(requisite.index, $event)"
                                                    color="teal"
                                                    :first-day-of-week="1"
                                                >
                                                </v-date-picker>
                                            </v-menu>

                                            <!-- Сотрудник -->
                                            <template v-if="requisite.RequisiteType == 3">
                                                <template v-if="requisite.IsRequired">
                                                    <div v-if="requisite.Value" class="onlyReadData">
                                                        <v-workplace-chip 
                                                            :id="requisite.Value"
                                                            :name="requisite.DisplayValue"
                                                            :canDelete="editable"
                                                            :delFunc="() => onDelete(requisite.index)"
                                                        />
                                                    </div>
                                                    <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                        <v-select-members-chip
                                                            target-type="Member"
                                                            @on-select="(e) => onSelectChip(e, requisite)"
                                                            :items-params="{ includeInner: true, includeOuter: false, multiple: false, selected: [] }"
                                                            :required="true"
                                                        />
                                                    </div>
                                                </template>
                                                <div v-else class="onlyReadData">
                                                    <v-workplace-chip v-if="requisite.Value"
                                                        :id="requisite.Value"
                                                        :name="requisite.DisplayValue"
                                                        :canDelete="editable"
                                                        :delFunc="() => onDelete(requisite.index)"
                                                    />
                                                    <template v-else>
                                                        <v-select-members-chip
                                                            target-type="Member"
                                                            @on-select="(e) => onSelectChip(e, requisite)"
                                                            :items-params="{ includeInner: true, includeOuter: false, multiple: false, selected: [] }"
                                                        />
                                                    </template>
                                                </div>
                                            </template>

                                            <!-- Организация -->
                                            <template v-if="requisite.RequisiteType == 4">
                                                <template v-if="requisite.IsRequired">
                                                    <div v-if="requisite.Value" class="onlyReadData">
                                                        <v-enterprise-chip
                                                            :id="requisite.Value"
                                                            :name="requisite.DisplayValue"
                                                            :canDelete="editable"
                                                            :delFunc="() => onDelete(requisite.index)"
                                                        />
                                                    </div>
                                                    <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                        <v-select-members-chip
                                                            target-type="Member"
                                                            @on-select="(e) => onSelectChip(e, requisite)"
                                                            :items-params="{ includeOuterEnterprises: true, includeJuridical: true, multiple: false, selected: [] }"
                                                            :required="true"
                                                        />
                                                    </div>
                                                </template>                                                
                                                <div v-else class="onlyReadData">
                                                    <v-enterprise-chip v-if="requisite.Value"
                                                        :id="requisite.Value"
                                                        :name="requisite.DisplayValue"
                                                        :canDelete="editable"
                                                        :delFunc="() => onDelete(requisite.index)"
                                                    />
                                                    <template v-else>
                                                        <v-select-members-chip
                                                            target-type="Member"
                                                            @on-select="(e) => onSelectChip(e, requisite)"
                                                            :items-params="{ includeOuterEnterprises: true, includeJuridical: true, multiple: false, selected: [] }"
                                                        />
                                                    </template>
                                                </div>
                                            </template>

                                        </div>
                                    </template>
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <div v-else class="cfl-placeholder">
                {{ $t("Нет_колонок_для_отображения") }}
            </div>
        </v-form>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';

const customName = 'custom';

export default {
    name: "RequisitesTab",
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        scheme: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule', notNullRule: 'getNotNullRule' }),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource' }),
        columns() {
            return JSON.parse(this.scheme) ?? [];
        }
    },
    data() {
        return {
            dateMenus: []
        }
    },
    methods: {
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        isCustom(obj) {
            return obj.group === customName;
        },
        getColumnRequisites(fieldsArray) {
            let result = [];

            if (!Array.isArray(fieldsArray) || !fieldsArray.length)
                return result;
            
            fieldsArray.forEach(f => {
                let index = this.dataSource.Data.Object.Document.Template.Requisites.findIndex(x => x.KeyName === f.key);

                if (index >= 0)
                    result.push(({ index, ...this.dataSource.Data.Object.Document.Template.Requisites[index] }));
            });

            return result;
        },
        onDateInput(index, value) {
            this.updateSource({ property: `Data.Object.Document.Template.Requisites[${index}].Value`, value });
            this.dateMenus[index] = false;
        },
        async onSelect(requisite) {
            try
            {
                let selectMemberParams = null;
                let value = null;
                let displayValue = null;

                switch (requisite.RequisiteType) {
                    case 3:
                    {
                        selectMemberParams = { title: this.$t("Выбор_сотрудника"), includeInner: true, includeOuter: false, multiple: false, selected: [ requisite.Value ] };
                        let { workplaceId, name } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                        value = workplaceId;
                        displayValue = name;
                        break;
                    }
                    case 4:
                    {
                        selectMemberParams = { title: this.$t("Выбор_организации"), includeOuterEnterprises: true, includeJuridical: true, multiple: false, selected: [ requisite.Value ] };
                        let { enterprise, name } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                        value = enterprise;
                        displayValue = name;
                        break;
                    }
                    default:
                        break;
                }

                this.updateSource({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].Value`, value });
                this.updateSource({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].DisplayValue`, value: displayValue });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        onDelete(index) {
            this.updateSource({ property: `Data.Object.Document.Template.Requisites[${index}].Value`, value: null });
            this.updateSource({ property: `Data.Object.Document.Template.Requisites[${index}].DisplayValue`, value: null });
        },
        onSelectChip(e, requisite) {
            let identifier = null;

            switch (requisite.RequisiteType) {
                case 3:
                    identifier = e.value.workplaceId;
                    break;

                case 4:
                    identifier = e.value.enterprise;
                    break;

                default:
                    break;
            }

            this.updateSource({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].Value`, value: identifier });
            this.updateSource({ property: `Data.Object.Document.Template.Requisites[${requisite.index}].DisplayValue`, value: e.value.name });
        },
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250),
    },
    created() {
        (async() => {
            while(typeof this.$refs.reqForm === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));
            
            this.dataSource.Data.Object.Document.Template.Requisites.forEach((r, i) => {
                if (r.RequisiteType == 1 && r.Value == null)
                    this.updateSource({ property: `Data.Object.Document.Template.Requisites[${i}].Value`, value: false });
            });

            this.$refs?.reqForm?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.reqForm?.validate();
        }  
    }
}
</script>